import React from 'react';

const Footer = () => {
    return (
        <div style={{ textAlign: 'center'}}>
            <p> Developed by <a style={{textDecoration: 'none', fontWeight: 'bold'}} href="https://github.com/bdmostafa" target="_blank">Mostafa</a></p>
        </div>
    );
};

export default Footer;